// Package Imports
// import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );
const NoDuesCertificate = lazy(
  () => import('pages/noDuesCertificate/noDuesCertificate')
);
const NoDuesCertificateRoute = (
  <Route path={routeName.noDuesCertificate}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.NO_DUES_CERTIFICATE_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <NoDuesCertificate />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default NoDuesCertificateRoute;
